export * from './language.service';
export * from './language-update.component';
export * from './language-delete-dialog.component';
export * from './language-detail.component';
export * from './language.component';
export * from './language.route';
